var help = "https://shopfront-cdn.tekoapis.com/static/a0ef8604f5a51c92.svg";

export { help as default };
